import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const ProfileTabs = ({ value, onChange, userId }) => {
  const history = useHistory();
  const location = useLocation();

  // Parse tab from URL query parameter
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    
    if (tabParam) {
      const tabIndex = ['summary', 'history', 'stats', 'friends'].indexOf(tabParam);
      if (tabIndex !== -1 && tabIndex !== value) {
        onChange(null, tabIndex);
      }
    }
  }, [location.search]);

  const handleChange = (event, newValue) => {
    const tabNames = ['summary', 'history', 'stats', 'friends'];
    const params = new URLSearchParams(location.search);
    params.set('tab', tabNames[newValue]);
    
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
    
    onChange(event, newValue);
  };

  return (
    <Box
      sx={{
        width: '100%',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        marginTop: '2rem',
        marginBottom: '2rem',
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: '#E8A33D',
            height: '3px',
          },
          '& .MuiTab-root': {
            color: '#999999',
            fontSize: '0.95rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            padding: '1rem 1.5rem',
            minHeight: 'auto',
            transition: 'color 150ms ease',
            '&:hover': {
              color: '#ffffff',
            },
            '&.Mui-selected': {
              color: '#E8A33D',
            },
          },
        }}
      >
        <Tab label="SUMMARY" />
        <Tab label="MATCH HISTORY" />
        <Tab label="STATS" />
        <Tab label="FRIENDS" />
      </Tabs>
    </Box>
  );
};

ProfileTabs.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  userId: PropTypes.string,
};

export default ProfileTabs;
